import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hideandskincustomeropinion',
  templateUrl: './hideandskincustomeropinion.component.html',
  styleUrls: ['./hideandskincustomeropinion.component.scss']
})
export class HideandskincustomeropinionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
